module.exports = __webpack_public_path__ + "static/media/backlight4.efcb460c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Backlight/backlight4.jpg
// module id = 315
// module chunks = 0